export const createDefaultAboutPageContent = () => ({
  badge: 'Chi siamo',
  title: 'Sapori 1989, cucina quotidiana con attenzione vera',
  subtitle:
    'Prepariamo piatti disponibili ogni giorno, menu completi, bevande e soluzioni veloci per chi vuole mangiare bene, ritirare in sede o ricevere a domicilio.',
  intro:
    'Sapori 1989 nasce per offrire una cucina concreta, curata e semplice da ordinare. Ogni giorno organizziamo menu e proposte pensate per il pranzo, con un servizio rapido e una gestione chiara degli ordini.',
  story_title: 'La nostra idea di cucina',
  story_text:
    "Lavoriamo su piatti genuini, preparazioni equilibrate e una proposta che cambia durante la settimana. L'obiettivo e dare un punto di riferimento affidabile a chi cerca qualita, praticita e gusto in un unico posto.",
  quality_title: 'Cosa trovi da noi',
  quality_text:
    'Menu del giorno, piatti unici, menu completi e una selezione di bevande e specialita da aggiungere facilmente al tuo ordine. Tutto e pensato per essere chiaro, veloce e ordinabile anche da smartphone.',
  service_title: 'Come ti serviamo',
  service_text:
    'Puoi scegliere tra ritiro in sede e consegna a domicilio. Organizziamo la ricezione degli ordini in modo semplice, cosi il cliente sa subito cosa ordinare e come riceverlo.',
  values_title: 'I nostri punti forti',
  value_1_title: 'Cucina quotidiana',
  value_1_text: 'Proposte pensate per il giorno, con piatti chiari e subito ordinabili.',
  value_2_title: 'Ordine semplice',
  value_2_text: 'Navigazione rapida, carrello immediato e scelta tra ritiro o consegna.',
  value_3_title: 'Attenzione al cliente',
  value_3_text: 'Diamo valore alla puntualita, alla chiarezza e alla qualita del servizio.',
  cta_title: 'Passa da noi o ordina online',
  cta_text:
    'Scopri il menu completo e scegli il modo piu comodo per ricevere il tuo ordine.',
});
